var oppo_nn = {
    name: "oppo nn",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [67,0,4,147,2,23,6,152,2,204,1,118,35,98,17,153,2,0,0,53,173,119,109,213,181,226],
        },
        {
            // function: "KEY_INPUT",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [67,0,4,152,2,18,6,157,2,199,1,145,35,71,17,171,2,0,0,53,173,119,117,106,189,226],
        },
        {
            function: "KEY_OPEN",
            name: "KEY_OPEN",
            icon: "KEY_OPEN",
            command: [67,0,4,141,2,27,6,149,2,209,1,121,35,92,17,158,2,0,0,53,173,119,123,170,181,226],
        },
        {
            function: "KEY_PURE_AUDIO",
            name: "KEY_PURE_AUDIO",
            icon: "KEY_PURE_AUDIO",
            command: [67,0,4,154,2,22,6,152,2,198,1,146,35,73,17,161,2,0,0,53,173,119,117,86,191,98],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [67,0,4,151,2,21,6,155,2,199,1,145,35,74,17,176,2,0,0,53,173,119,125,170,173,226],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,143,2,27,6,148,2,210,1,129,35,93,17,153,2,0,0,53,173,119,122,213,93,226],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [67,0,4,143,2,30,6,146,2,210,1,125,35,93,17,151,2,0,0,53,173,119,122,173,95,98],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [67,0,4,156,2,14,6,158,2,198,1,148,35,64,17,159,2,0,0,53,173,119,123,85,91,226],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [67,0,4,150,2,26,6,154,2,198,1,132,35,88,17,151,2,0,0,53,173,119,125,85,87,226],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [67,0,4,153,2,23,6,151,2,200,1,127,35,91,17,158,2,0,0,53,173,119,122,170,175,226],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [67,0,4,149,2,17,6,155,2,206,1,144,35,77,17,160,2,0,0,53,173,119,109,170,219,226],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,153,2,20,6,151,2,203,1,147,35,59,17,158,2,0,0,53,173,119,110,170,215,226],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [67,0,4,152,2,20,6,152,2,205,1,142,35,85,17,161,2,0,0,53,173,119,109,85,111,226],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [67,0,4,151,2,25,6,150,2,200,1,137,35,81,17,147,2,0,0,53,173,119,117,170,187,226],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [67,0,4,152,2,18,6,155,2,202,1,167,35,84,17,161,2,0,0,53,173,119,118,170,183,226],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [67,0,4,144,2,29,6,142,2,209,1,119,35,93,17,151,2,0,0,53,173,119,117,85,95,226],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [67,0,4,151,2,19,6,150,2,204,1,147,35,75,17,185,2,0,0,53,173,119,107,85,119,226],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [67,0,4,147,2,23,6,151,2,207,1,140,35,81,17,158,2,0,0,53,173,119,110,173,175,98],
        },
        {
            function: "KEY_GOTO",
            name: "KEY_GOTO",
            icon: "KEY_GOTO",
            command: [67,0,4,148,2,17,6,156,2,205,1,135,35,82,17,169,2,0,0,53,173,119,109,173,183,98],
        },
        {
            function: "KEY_HOME",
            name: "KEY_HOME",
            icon: "KEY_HOME",
            command: [67,0,4,131,2,31,6,141,2,220,1,152,35,94,17,151,2,0,0,53,173,119,107,219,171,98],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [67,0,4,130,2,33,6,142,2,221,1,103,35,99,17,140,2,0,0,53,173,119,111,182,171,98],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [67,0,4,144,2,27,6,150,2,206,1,124,35,86,17,147,2,0,0,53,173,119,119,181,171,98],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [67,0,4,147,2,21,6,152,2,210,1,130,35,64,17,159,2,0,0,53,173,119,107,86,239,98],
        },
        {
            // function: "KEY_TOPMENU",
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,138,2,32,6,139,2,221,1,126,35,96,17,141,2,0,0,53,173,119,106,214,247,98],
        },
        {
            function: "KEY_POPUPMENU",
            name: "KEY_POPUPMENU",
            icon: "KEY_POPUPMENU",
            command: [67,0,4,135,2,37,6,137,2,220,1,126,35,85,17,142,2,0,0,53,173,119,106,171,127,98],
        },
        {
            function: "KEY_OPTION",
            name: "KEY_OPTION",
            icon: "KEY_OPTION",
            command: [67,0,4,133,2,34,6,138,2,220,1,130,35,93,17,144,2,0,0,53,173,119,106,237,235,98],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [67,0,4,131,2,32,6,141,2,222,1,126,35,96,17,152,2,0,0,53,173,119,109,86,223,98],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [67,0,4,134,2,35,6,139,2,218,1,123,35,90,17,143,2,0,0,53,173,119,107,213,213,226],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [67,0,4,135,2,38,6,138,2,218,1,127,35,79,17,151,2,0,0,53,173,119,119,170,213,226],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [67,0,4,138,2,35,6,136,2,219,1,117,35,97,17,148,2,0,0,53,173,119,127,85,85,226],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [67,0,4,136,2,34,6,137,2,218,1,123,35,95,17,143,2,0,0,53,173,119,111,171,85,226],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [67,0,4,132,2,32,6,142,2,224,1,119,35,92,17,139,2,0,0,53,173,119,109,109,187,98],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [67,0,4,133,2,30,6,146,2,220,1,127,35,92,17,143,2,0,0,53,173,119,110,219,91,98],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,131,2,33,6,140,2,221,1,127,35,93,17,149,2,0,0,53,173,119,107,106,237,226],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [67,0,4,132,2,32,6,140,2,223,1,154,35,65,17,153,2,0,0,53,173,119,107,109,219,98],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [67,0,4,136,2,34,6,138,2,221,1,145,35,94,17,143,2,0,0,53,173,119,106,182,251,98],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [67,0,4,129,2,34,6,144,2,219,1,125,35,92,17,152,2,0,0,53,173,119,118,218,219,98],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,138,2,30,6,138,2,220,1,121,35,89,17,152,2,0,0,53,173,119,117,109,123,98],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [67,0,4,135,2,36,6,139,2,220,1,123,35,87,17,145,2,0,0,53,173,119,125,90,175,98],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [67,0,4,132,2,32,6,141,2,220,1,130,35,87,17,149,2,0,0,53,173,119,123,90,183,98],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [67,0,4,136,2,35,6,138,2,220,1,124,35,62,17,145,2,0,0,53,173,119,118,173,111,98],
        },
        {
            function: "KEY_DIMMER",
            name: "KEY_DIMMER",
            icon: "KEY_DIMMER",
            command: [67,0,4,135,2,38,6,135,2,220,1,116,35,101,17,145,2,0,0,53,173,119,127,106,171,98],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [67,0,4,139,2,35,6,131,2,221,1,126,35,88,17,146,2,0,0,53,173,119,106,170,191,226],
        },
        {
            function: "KEY_ABREPLAY",
            name: "KEY_ABREPLAY",
            icon: "KEY_ABREPLAY",
            command: [67,0,4,133,2,32,6,144,2,220,1,129,35,88,17,148,2,0,0,53,173,119,119,90,215,98],
        },
        {
            function: "KEY_REPEAT",
            name: "KEY_REPEAT",
            icon: "KEY_REPEAT",
            command: [67,0,4,132,2,37,6,139,2,221,1,123,35,94,17,148,2,0,0,53,173,119,107,173,215,98],
        },
        {
            function: "KEY_PIC",
            name: "KEY_PIC",
            icon: "KEY_PIC",
            command: [67,0,4,133,2,36,6,137,2,220,1,111,35,90,17,140,2,0,0,53,173,119,111,85,171,226],
        },
        {
            function: "KEY_RESOLUTION",
            name: "KEY_RESOLUTION",
            icon: "KEY_RESOLUTION",
            command: [67,0,4,131,2,38,6,137,2,220,1,130,35,93,17,147,2,0,0,53,173,119,118,213,109,226],
        },
        {
            function: "KEY_HDR",
            name: "KEY_HDR",
            icon: "KEY_HDR",
            command: [67,0,4,133,2,38,6,135,2,220,1,126,35,96,17,149,2,0,0,53,173,119,106,213,123,226],
        },
    ]
}
export default oppo_nn